import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';

function shouldSetJsonContentType(req: HttpRequest<any>): boolean {
  // Só para métodos com corpo e quando o body NÃO é FormData/Blob
  if (!['POST', 'PUT', 'PATCH'].includes(req.method)) return false;

  const isFormData = req.body instanceof FormData;
  const isBlob = req.body instanceof Blob;

  return !isFormData && !isBlob;
}


export const clientInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  // console.log(" Usando interceptador de cliente..")
  // const newHeader = req.clone({
  //   setHeaders: {
  //     'Authorization': localStorage.getItem('token') ?? '',
  //     'Content-Type': 'application/json'
  //   }
  // })
  // return next(newHeader);


  //Novo codigo
  let headers = req.headers;

  // Auth, se houver
  const token = localStorage.getItem('token');
  if (token && !headers.has('token')) {
    headers = headers.set('Authorization', token);
  }

  // Não force JSON quando for FormData/Blob (upload)
  if (shouldSetJsonContentType(req) && !headers.has('Content-Type')) {
    headers = headers.set('Content-Type', 'application/json');
  }

  // Se por algum motivo já veio 'Content-Type' mas o body é FormData/Blob, remova
  const isFormData = req.body instanceof FormData;
  const isBlob = req.body instanceof Blob;
  if ((isFormData || isBlob) && headers.has('Content-Type')) {
    headers = headers.delete('Content-Type'); // deixa o browser setar o boundary corretamente
  }

  const cloned = req.clone({ headers });
  return next(cloned);
};
